import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllYoutubeCmsConfirmedAssets.graphql';
import { Query, QueryallYoutubeCmsConfirmedAssetsArgs } from '../../__generated__/globalTypes';

export const useAllYoutubeCmsConfirmedAssetsQuery = (
  options?: QueryHookOptions<Query, QueryallYoutubeCmsConfirmedAssetsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallYoutubeCmsConfirmedAssetsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllYoutubeCmsConfirmedAssetsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallYoutubeCmsConfirmedAssetsArgs>
): QueryResult<Query, QueryallYoutubeCmsConfirmedAssetsArgs> & {
  getAllYoutubeCmsConfirmedAssets: LazyQueryExecFunction<Query, QueryallYoutubeCmsConfirmedAssetsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllYoutubeCmsConfirmedAssets, result] = useLazyQuery<Query, QueryallYoutubeCmsConfirmedAssetsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllYoutubeCmsConfirmedAssets, ...result };
};

export const useAllYoutubeCmsConfirmedAssetsPromiseQuery = () => {
  const client = useApolloClient();

  const getAllYoutubeCmsConfirmedAssets = useCallback(
    (options?: Omit<QueryOptions<QueryallYoutubeCmsConfirmedAssetsArgs, Query>, 'query'>) =>
      client.query<Query, QueryallYoutubeCmsConfirmedAssetsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllYoutubeCmsConfirmedAssets };
};
// Suspense Query Hooks
export const useAllYoutubeCmsConfirmedAssetsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallYoutubeCmsConfirmedAssetsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallYoutubeCmsConfirmedAssetsArgs>(QUERY, {
    ...options
  });

  return result;
};
